import axios from "axios";
import { Message } from 'element-ui'

export default function request(url, method, data, header = 'application/json', obj = { responseType: 'json' }){
  return new Promise((resolve, reject) => {
    // 1.创建axios的实例
    const instance = axios.create({
      withCredentials: true,
      baseURL: '/api',
      // timeout: 5000,
    })
    // 响应拦截
    instance.interceptors.response.use(response => {
      // console.log(response)
      if(response.data.code === 1000){
        if(response.config.url === '/user/userInfo' || response.config.url === '/tryLogin.action'
        || response.config.url === '/product/addProduct'|| response.config.url === '/product/getSales' || response.config.url === '/config-service/storeConfig/getAll'){
          return response;
        }
        else {
          Message.error(response.data.info)
          // location.reload();
        }
      }else{
        return response
      }
    },error => {
      // Message.error('url:' + config.url + `\r\n` + error)
      reject(error)
    })
    // 发送真正的网络请求
    instance({
      url: url,
      method: method,
      data: data,
      header: {
        'Content-Type': header ? header : 'application/json'
      },
      responseType: obj.responseType ?  obj.responseType : 'json'
    }).then( res => {
      if(res.data.code === 1){
        resolve(res)
      }else{
        resolve(res)
      }
    }).catch( err => {
      reject(err)
    })
  })
}
